module.exports = __webpack_public_path__ + "img/hall5.a4cd9328.jpg";